/**
 * Nuxt plugin for setting up a global event bus in non-federated environments.
 *
 * This plugin attaches the window's eventBus to the Vue app's global properties
 * if the application is not running in a federated mode.
 *
 * @param {Object} nuxtApp - The Nuxt application instance
 * @returns {void}
 * @see https://nuxt.com/docs/guide/directory-structure/plugins
 */
export default defineNuxtPlugin(nuxtApp => {
  if (useRuntimeConfig().public.isFederated) return

  // @ts-ignore
  nuxtApp.vueApp.config.globalProperties.$eventBus = window.eventBus
})
